/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Classification_Human_OperatedInputs */

const en_directory_agent_readiness_classification_human_operated = /** @type {(inputs: Directory_Agent_Readiness_Classification_Human_OperatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human operated`)
};

const zh_directory_agent_readiness_classification_human_operated = /** @type {(inputs: Directory_Agent_Readiness_Classification_Human_OperatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以人工操作为主`)
};

/**
* | output |
* | --- |
* | "Human operated" |
*
* @param {Directory_Agent_Readiness_Classification_Human_OperatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_classification_human_operated = /** @type {((inputs?: Directory_Agent_Readiness_Classification_Human_OperatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Classification_Human_OperatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_classification_human_operated(inputs)
	return zh_directory_agent_readiness_classification_human_operated(inputs)
});
export { directory_agent_readiness_classification_human_operated as "directory.agent_readiness.classification.human_operated" }